import { upsertReviewBaseFingerprintExtension } from '@lifeomic/phc-web-toolkit/src/util/contentFingerprint';

export const DATASET_TAG_SYSTEM = 'http://lifeomic.com/fhir/dataset';
export const IMPRESSION_TYPE_SYSTEM =
  'http://lifeomic.com/fhir/fountain-life-clinical-impression-type';
export const IMPRESSION_TEMPLATE_TYPE_CODE = 'templated-report';
export const IMPRESSION_AI_GENERATED_EXTENSION =
  'https://lifeomic.com/fhir/fountain-life-ai-generated';
export const ZORI_CHAT_SOURCE_POST_EXTENSION =
  'https://lifeomic.com/fhir/zori-chat-source-post-id';

type BuildZoriChatReportInput = {
  impressionId: string;
  patientId: string;
  projectId: string;
  postId: string;
  message: string;
  exportedAt?: Date;
};

export const buildZoriChatReportTitle = (exportedAt: Date): string =>
  `Zori Chat Export - ${exportedAt.toISOString().slice(0, 10)}`;

export const buildZoriChatReportResource = ({
  impressionId,
  patientId,
  projectId,
  message,
  exportedAt = new Date(),
  extension,
}: BuildZoriChatReportInput & {
  extension: fhir3.ClinicalImpression['extension'];
}): fhir3.ClinicalImpression & { id: string } => ({
  resourceType: 'ClinicalImpression',
  id: impressionId,
  status: 'draft',
  date: exportedAt.toISOString(),
  description: buildZoriChatReportTitle(exportedAt),
  summary: message,
  subject: {
    reference: `Patient/${patientId}`,
  },
  code: {
    text: 'Zori Report',
    coding: [
      {
        system: IMPRESSION_TYPE_SYSTEM,
        code: 'general',
        display: 'General',
      },
    ],
  },
  meta: {
    tag: [
      {
        system: DATASET_TAG_SYSTEM,
        code: projectId,
      },
      {
        system: IMPRESSION_TYPE_SYSTEM,
        code: IMPRESSION_TEMPLATE_TYPE_CODE,
      },
    ],
  },
  extension,
});

export const buildZoriChatReportClinicalImpression = async (
  input: BuildZoriChatReportInput,
): Promise<fhir3.ClinicalImpression & { id: string }> => {
  const extension = await upsertReviewBaseFingerprintExtension(
    [
      {
        url: IMPRESSION_AI_GENERATED_EXTENSION,
        valueBoolean: true,
      },
      {
        url: ZORI_CHAT_SOURCE_POST_EXTENSION,
        valueString: input.postId,
      },
    ],
    input.message,
  );

  return buildZoriChatReportResource({
    ...input,
    extension,
  });
};
